import React, { useEffect, useState, useRef } from "react";
import NotificationAlert from "react-notification-alert";
// reactstrap components
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  Table,
  FormGroup,
  Form,
  Input,
  Row,
  Col,
  CardTitle,
} from "reactstrap";
import useToken from "../helpers/useToken";
import useTimeZone from "../helpers/useTimeZone";
import { useParams } from "react-router-dom";
import { parseCustomTime } from "../helpers/utils";
import TMHLoader from "components/TMHLoader/TMHLoader";

function EditUser() {
  const { userId } = useParams();
  const notificationAlertRef = useRef(null);

  const notify = (
    place = "tl",
    message = "",
    type = "success",
    autoDismiss = 5
  ) => {
    var options = {};
    options = {
      place: place,
      message: <div>{message}</div>,
      type: type,
      icon: "tim-icons icon-bell-55",
      autoDismiss: autoDismiss,
    };
    notificationAlertRef.current.notificationAlert(options);
  };

  useEffect(() => {
    document.title = "TMH Admin - Edit User";
  });

  const [userData, setUserData] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const { token } = useToken();
  const { timeZone } = useTimeZone();
  const handleSubmitUserData = async (e) => {
    setIsLoading(true);
    e.preventDefault();

    console.log("EditUser: submit user data");
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Cache-Control", "no-cache");
    myHeaders.append("Access-Token", token);

    var requestOptions = {
      method: "PUT",
      headers: myHeaders,
      body: JSON.stringify({
        first_name: userData?.first_name,
        last_name: userData?.last_name,
        progress: parseFloat(userData?.progress),
      }),
    };

    fetch(process.env.REACT_APP_BASE_URL + "users/" + userId, requestOptions)
      .then((response) => {
        return new Promise((resolve) =>
          response.json().then((json) =>
            resolve({
              status: response.status,
              ok: response.ok,
              json,
            })
          )
        );
      })
      .then(async (result) => {
        var json = result.json;
        // console.log(json)
        if (result.ok) {
          setUserData(json.data);
          notify("tl", "Update User Success!");
        } else {
          console.log(result.json.message);
          // setUserData()
          notify("tl", "Update User Failed!", "danger");
        }
        setIsLoading(false);
      });
  };

  useEffect(() => {
    const initData = async () => {
      setIsLoading(true);
      console.log("EditUser: get data");
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append("Cache-Control", "no-cache");
      myHeaders.append("Access-Token", token);

      var requestOptions = {
        method: "GET",
        headers: myHeaders,
      };

      fetch(process.env.REACT_APP_BASE_URL + "users/" + userId, requestOptions)
        .then((response) => {
          return new Promise((resolve) =>
            response.json().then((json) =>
              resolve({
                status: response.status,
                ok: response.ok,
                json,
              })
            )
          );
        })
        .then(async (result) => {
          var json = result.json;
          // console.log(json)
          if (result.ok) {
            setUserData(json.data);
          } else {
            console.log(result.json.message);
            setUserData();
          }
          setIsLoading(false);
        });
    };

    initData();
    document.title = "Edit User - TMH Admin";
  }, [token, userId]);

  return (
    <>
      <div className="content">
        <div className="react-notification-alert-container">
          <NotificationAlert ref={notificationAlertRef} />
        </div>
        <TMHLoader active={isLoading}>
          <Row>
            <Col md="4">
              <Card>
                <CardHeader>
                  <h5 className="title">Edit User Profile</h5>
                </CardHeader>
                <CardBody>
                  <Form onSubmit={handleSubmitUserData}>
                    <Row>
                      <Col className="pr-md-1" md="6">
                        <FormGroup>
                          <label>First Name</label>
                          <Input
                            value={userData?.first_name}
                            placeholder="First Name"
                            type="text"
                            onChange={(e) =>
                              setUserData({
                                ...userData,
                                first_name: e.target.value,
                              })
                            }
                          />
                        </FormGroup>
                      </Col>
                      <Col className="pl-md-1" md="6">
                        <FormGroup>
                          <label>Last Name</label>
                          <Input
                            value={userData?.last_name}
                            placeholder="Last Name"
                            type="text"
                            onChange={(e) =>
                              setUserData({
                                ...userData,
                                last_name: e.target.value,
                              })
                            }
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col md="12">
                        <FormGroup>
                          <label>Email (disabled)</label>
                          <Input
                            value={userData?.email}
                            disabled
                            placeholder="Email"
                            type="text"
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col md="12">
                        <FormGroup>
                          <label>Address (disabled)</label>
                          <Input
                            value={userData?.address}
                            disabled
                            placeholder="Address"
                            type="text"
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col className="pr-md-1" md="6">
                        <FormGroup>
                          <label>Last IP (disabled)</label>
                          <Input
                            disabled
                            value={
                              userData?.user_ips?.length > 0
                                ? userData.user_ips[0].ip_address +
                                  " (" +
                                  userData.user_ips[0].country_code +
                                  ")"
                                : ""
                            }
                            placeholder="IP"
                            type="text"
                          />
                        </FormGroup>
                      </Col>
                      <Col className="pl-md-1" md="6">
                        <FormGroup>
                          <label>Current Progress</label>
                          <Input
                            value={userData?.progress}
                            placeholder="Progress"
                            onChange={(e) =>
                              setUserData({
                                ...userData,
                                progress: e.target.value,
                              })
                            }
                            min="0"
                            max="100"
                            type="number"
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col className="pr-md-1" md="6">
                        <FormGroup>
                          <label>Country Code (disabled)</label>
                          <Input
                            disabled
                            value={userData?.user_ip?.country_code}
                            placeholder="Country Code"
                            type="text"
                          />
                        </FormGroup>
                      </Col>
                      <Col className="pl-md-1" md="6">
                        <FormGroup>
                          <label>City (disabled)</label>
                          <Input
                            disabled
                            value={userData?.user_ip?.city}
                            placeholder="City"
                            type="text"
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col className="pr-md-1" md="12">
                        <FormGroup>
                          <label>User-Agent (disabled)</label>
                          <Input
                            disabled
                            value={userData?.user_ip?.user_agent}
                            placeholder="Region"
                            type="textarea"
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <Button className="btn-fill" color="primary" type="submit">
                      Save
                    </Button>
                  </Form>
                </CardBody>
              </Card>
            </Col>
            <Col md="8">
              <Card className="card-user">
                <CardHeader>
                  <h5 className="title">
                    Sign up date:{" "}
                    {parseCustomTime(userData?.sign_up_date, timeZone)}
                  </h5>
                </CardHeader>

                <CardBody>
                  <Row>
                    <Col md="3">
                      <Card>
                        <CardHeader>
                          <CardTitle tag="h3">
                            {" "}
                            <b>Round</b>{" "}
                          </CardTitle>
                          <h1 className="text-center">
                            {userData?.round ?? "..."}
                          </h1>
                        </CardHeader>
                      </Card>
                    </Col>
                    <Col md="3">
                      <Card>
                        <CardHeader>
                          <CardTitle tag="h3">
                            {" "}
                            <b>Codes redeemed</b>{" "}
                          </CardTitle>
                          <h1 className="text-center">
                            {userData?.code_redeemed ?? "..."}
                          </h1>
                        </CardHeader>
                      </Card>
                    </Col>
                    <Col md="3">
                      <Card>
                        <CardHeader>
                          <CardTitle tag="h3">
                            {" "}
                            <b>Spins</b>{" "}
                          </CardTitle>
                          <h1 className="text-center">
                            {userData?.spins ?? "..."}
                          </h1>
                        </CardHeader>
                      </Card>
                    </Col>
                    <Col md="3">
                      <Card>
                        <CardHeader>
                          <CardTitle tag="h3">
                            {" "}
                            <b>Streaks</b>{" "}
                          </CardTitle>
                          <h1 className="text-center">
                            {userData?.streaks ?? "..."}
                          </h1>
                        </CardHeader>
                      </Card>
                    </Col>
                  </Row>
                  <Row>
                    <Col md="3">
                      <Card>
                        <CardHeader>
                          <CardTitle tag="h4">
                            {" "}
                            <b>Adverts served</b>{" "}
                          </CardTitle>
                          <h1 className="text-center">
                            {userData?.adverts_served ?? "..."}
                          </h1>
                        </CardHeader>
                      </Card>
                    </Col>
                    <Col md="3">
                      <Card>
                        <CardHeader>
                          <CardTitle tag="h4">
                            {" "}
                            <b>Mins/Hours watched</b>{" "}
                          </CardTitle>
                          <h1 className="text-center">
                            {userData?.minutes_watched
                              ? userData.minutes_watched +
                                "/" +
                                parseFloat(
                                  userData.minutes_watched / 60
                                ).toFixed(1)
                              : "..."}
                          </h1>
                        </CardHeader>
                      </Card>
                    </Col>
                    <Col md="3">
                      <Card>
                        <CardHeader>
                          <CardTitle tag="h4">
                            {" "}
                            <b>Roku Remote</b>{" "}
                          </CardTitle>
                          <h4>
                            Installed
                            {userData?.roku_remote?.is_installed ? (
                              <i
                                style={{ color: "green" }}
                                className="ml-5 fa fa-check"
                              ></i>
                            ) : (
                              <i
                                style={{ color: "red" }}
                                className="ml-5 fa fa-times"
                              ></i>
                            )}
                          </h4>
                          <h4>
                            Accessibility
                            {userData?.roku_remote?.is_accept_accessibility ? (
                              <i
                                style={{ color: "green" }}
                                className="ml-3 fa fa-check"
                              ></i>
                            ) : (
                              <i
                                style={{ color: "red" }}
                                className="ml-3 fa fa-times"
                              ></i>
                            )}
                          </h4>
                        </CardHeader>
                      </Card>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Row>
            <Col md="12">
              <Card>
                <CardHeader>
                  <CardTitle tag="h4">IPs Log</CardTitle>
                </CardHeader>
                <CardBody>
                  <Table className="tablesorter" responsive>
                    <thead className="text-primary">
                      <tr>
                        <th>First Connect</th>
                        <th>Last Connect</th>
                        <th>IP Address</th>
                        <th>User Agent</th>
                        <th>Country</th>
                        <th>Region</th>
                        <th>City</th>
                        <th>IP's TimeZone</th>
                      </tr>
                    </thead>
                    <tbody>
                      {userData?.browser_history_arr &&
                        userData.user_ips.map((data, index) => {
                          return (
                            <tr key={index}>
                              <td>
                                {parseCustomTime(data.created_at, timeZone)}
                              </td>
                              <td>
                                {parseCustomTime(data.updated_at, timeZone)}
                              </td>
                              <td>{data.ip_address}</td>
                              <td>{data.user_agent}</td>
                              <td>{data.country_code}</td>
                              <td>{data.region}</td>
                              <td>{data.city}</td>
                              <td>{data.timezone}</td>
                            </tr>
                          );
                        })}
                    </tbody>
                  </Table>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Row>
            <Col md="12">
              <Card>
                <CardHeader>
                  <CardTitle tag="h4">
                    Recent claimed codes
                    <Table responsive style={{ maxWidth: 500, margin: 0 }}>
                      <thead className="text-primary">
                        <tr>
                          <th>
                            Total Request: {userData?.total_code_request ?? 0}
                          </th>
                          <th>Approved: {userData?.total_code ?? 0}</th>
                          <th>
                            Rejected:{" "}
                            {(userData?.total_code_request ?? 0) -
                              (userData?.total_code ?? 0)}
                          </th>
                        </tr>
                      </thead>
                    </Table>
                  </CardTitle>
                </CardHeader>
                <CardBody>
                  <Table className="tablesorter" responsive>
                    <thead className="text-primary">
                      <tr>
                        <th>Date of request</th>
                        <th>Code requested</th>
                      </tr>
                    </thead>
                    <tbody>
                      {userData?.recent_codes &&
                        userData.recent_codes.map((data, index) => {
                          return (
                            <tr key={index}>
                              <td>
                                {parseCustomTime(data.claimed_at, timeZone)}
                              </td>
                              <td>{data.code}</td>
                            </tr>
                          );
                        })}
                    </tbody>
                  </Table>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Row>
            <Col md="12">
              <Card>
                <CardHeader>
                  <CardTitle tag="h4">Browser History Log</CardTitle>
                </CardHeader>
                <CardBody>
                  <Table className="tablesorter" responsive>
                    <thead className="text-primary">
                      <tr>
                        <th>Date</th>
                        <th>Site</th>
                        <th>Browser</th>
                        <th>Roku ID</th>
                      </tr>
                    </thead>
                    <tbody>
                      {userData?.browser_history_arr &&
                        userData.browser_history_arr.map((data, index) => {
                          return (
                            <tr key={index}>
                              <td>
                                {parseCustomTime(
                                  data.date.substring(0, 11),
                                  timeZone
                                )}
                              </td>
                              <td>
                                {data.site && data.site.length > 30
                                  ? data.site.substring(0, 30) + " ..."
                                  : data.site}
                              </td>
                              <td>{data.browser}</td>
                              <td>{data.roku_id}</td>
                            </tr>
                          );
                        })}
                    </tbody>
                  </Table>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Row>
            <Col md="12">
              <Card>
                <CardHeader>
                  <CardTitle tag="h4">Admin History Log</CardTitle>
                </CardHeader>
                <CardBody>
                  <Table className="tablesorter" responsive>
                    <thead className="text-primary">
                      <tr>
                        <th>Date</th>
                        <th>Action</th>
                        <th>User</th>
                        <th>InFo</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>test</td>
                        <td>test</td>
                        <td>test</td>
                        <td>test</td>
                      </tr>
                    </tbody>
                  </Table>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </TMHLoader>
      </div>
    </>
  );
}

export default EditUser;
